import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output
} from "@angular/core";
import DataSource from "devextreme/data/data_source";
import { lastValueFrom } from "rxjs";
import { MemberBackend } from "src/app/backend/api/member.backend";
import { MemberLight } from "src/app/backend/models/member/member";
import { buildStaffDataSource } from "src/app/support/datasources/staff.datasource";

@Component({
  standalone: false,
  selector: "pms-soap-template-authors",
  templateUrl: "soap-template-authors.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ]
})
export class SoapTemplateAuthorsComponent implements OnInit {
  @Input()
  authors: Array<MemberLight> | undefined;

  @Input()
  preview: boolean = false;

  @Input()
  readOnly: boolean = false;

  @Output()
  data: EventEmitter<{ tags: MemberLight[] }> = new EventEmitter();

  private readonly memberBackend = inject(MemberBackend);

  tags: string[] = [];

  membersDataSource: DataSource;

  constructor() {
    this.membersDataSource = buildStaffDataSource({
      memberBackend: this.memberBackend
    });
  }

  ngOnInit(): void {
    this.tags = this.authors?.map((author) => author.id) || [];
  }

  async onAuthorsChanged(tags: any): Promise<void> {
    if (tags.value) {
      const members = await Promise.all(
        tags.value.map((tag: string) =>
          lastValueFrom(this.memberBackend.loadLight(tag))
        )
      );

      this.data.emit({
        tags: members
      });

      this.tags = tags.value;
    }
  }
}
